import { createTextFilterContext } from "@/components/TextFilter/createTextFilterContext";

export const patientsTextFilter = createTextFilterContext();

export const usePatientNameFilter = patientsTextFilter.useFilter;
export const usePatientNameFilterActions = patientsTextFilter.useFilterActions;
export const usePatientsFilterBannerItem =
  patientsTextFilter.useFilterBannerItem;
